import https from "../init/https";

//QB-BD-1: Retrieve list of all boards
export async function boardList(){
    const data = await https.get(`/boards`);
    return data;
}